import { createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
  body: {
    minWidth: '500px',
    minHeight: '400px',

    [theme.fn.smallerThan('sm')]: {
      minWidth: '100%',
    },
  },

  content: {
    transition: 'opacity 300ms ease-in-out',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    minHeight: '350px',
  },

  contentEnter: {
    opacity: 0,
  },
  contentEnterActive: {
    opacity: 1,
    transition: 'opacity 300ms ease-in-out',
  },
  contentExitActive: {
    opacity: 0,
    transition: 'opacity 300ms ease-in-out',
  },
  contentExit: {
    opacity: 1,
  },
}));

export default useStyles;
